/**
 * Mirrors a service's favourite state on its card, kept in sync through the
 * `favourite-toggled` browser event (bind it with `x-on:favourite-toggled.window="sync($event)"`).
 */
export default function favouriteButton({ serviceId, isFavourited = false }) {
    return {
        isFavourited,

        sync(event) {
            const detail = Array.isArray(event.detail) ? event.detail[0] : event.detail;

            if (detail?.serviceId === serviceId) {
                this.isFavourited = Boolean(detail.isFavourite);
            }
        },
    };
}
